import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/back-blue.png")